import StencilHTMLElement from "./stencil-element";

class CardLineItem extends StencilHTMLElement {
  name = "CardLineItem";
  key;
  removeButtons;
  quantityInputs;
  decreaseButtons;
  increaseButtons;

  constructor() {
    super();
  }

  connectedCallback() {
    // console.log(`hello from CardLineItem`);
    this.key = this.getAttribute('key');
    this.removeButtons = this.querySelectorAll('[data-remove]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.decreaseButtons = this.querySelectorAll('[data-quantity-decrease]');
    this.increaseButtons = this.querySelectorAll('[data-quantity-increase]');
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.removeButtons.forEach(button => {
      button.addEventListener('click', this.handleRemove.bind(this));
    });
    this.quantityInputs.forEach(input => {
      input.addEventListener('change', this.handleQuantityChange.bind(this));
    });
    this.decreaseButtons.forEach(button => {
      button.addEventListener('click', this.handleDecrease.bind(this));
    });
    this.increaseButtons.forEach(button => {
      button.addEventListener('click', this.handleIncrease.bind(this));
    });
  }

  handleRemove(e) {
    MP.Extensions.Cart.change({ id: this.key, quantity: 0 });
  }

  handleQuantityChange(e) {
    MP.Extensions.Cart.change({ id: this.key, quantity: e.target.value });
  }

  handleDecrease(e) {
    const input = e.target.closest('button').nextElementSibling;
    if (!input || !input.hasAttribute('data-quantity')) return;
    
    const currentValue = parseInt(input.value) || 1;
    
    if (currentValue === 1) {
      // If quantity is 1, remove the item
      this.handleRemove(e);
    } else {
      // Decrease quantity
      input.value = currentValue - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  handleIncrease(e) {
    const input = e.target.closest('button').previousElementSibling;
    if (!input || !input.hasAttribute('data-quantity')) return;
    
    input.value = parseInt(input.value) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

export default CardLineItem;